import React, { useState, useEffect } from 'react';
import '../CSS/Global.css';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useSidebar } from '../SidebarContext';
import Sidebar from './SideBar';
import Swal from "sweetalert2";
import { useNavigate } from 'react-router-dom';
import ExpandableCell from './Expandcell';

const formatPrice = (price) => {
    const num = parseInt(price, 10);
    if (isNaN(num)) return "Invalid Price";
    if (num >= 10000000) return `${(num / 10000000).toFixed(2)} Cr`;
    if (num >= 100000) return `${(num / 100000).toFixed(2)} L`;
    if (num >= 1000) return `${(num / 1000).toFixed(2)} K`;
    return num.toString();
};

const MyProjectUpdated = () => {
    const { isSidebarOpen } = useSidebar();

    const [searchQuery, setSearchQuery] = useState('');
    const [data, setData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [residentData, setResidentData] = useState([]);
    const [commData, setCommData] = useState([]);
    const [rentData, setRentData] = useState([]);


    const isLoggedIn = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || "";
    const BASE_URL = "https://100real.xyz";

    const handleSearch = (e) => {
        setSearchQuery(e.target.value);
        setCurrentPage(1);
    };


    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const handleNavigate = (url) => {
        window.location.href = url;
    };

    const parseProps = (item) => {
        const parseJSON = (val) => {
            try {
                return typeof val === 'string' ? JSON.parse(val) : val;
            } catch {
                return val;
            }
        };

        return {
            amenities: parseJSON(item.amenities || "[]"),
            carpetArea: parseJSON(item.carpetArea || "[]"),
            flatType: parseJSON(item.flatType || "[]"),
            expectedPrice: parseJSON(item.expectedPrice || "[]"),
            formImages: parseJSON(item.formImages || "[]"),
            locationAdvantage: parseJSON(item.locationAdvantage || item.locationAdvantage || "[]"),
        };
    };

    const fetchAll = async () => {
        try {
            const [res1, res2, res3] = await Promise.all([
                fetch(`${BASE_URL}/resident/getproperty/${isLoggedIn.user_id}`),
                fetch(`${BASE_URL}/commercial/getproperty/${isLoggedIn.user_id}`),
                fetch(`${BASE_URL}/rentresident/getproperty/${isLoggedIn.user_id}`)
            ]);

            const [json1, json2, json3] = await Promise.all([
                res1.json(),
                res2.json(),
                res3.json()
            ]);

            const parseProps = (item) => {
                const parseJSON = (val) => {
                    try {
                        return typeof val === 'string' ? JSON.parse(val) : val;
                    } catch {
                        return val;
                    }
                };
                return {
                    amenities: parseJSON(item.amenities || "[]"),
                    carpetArea: parseJSON(item.carpetArea || "[]"),
                    flatType: parseJSON(item.flatType || "[]"),
                    expectedPrice: parseJSON(item.expectedPrice || "[]"),
                    formImages: parseJSON(item.formImages || "[]"),
                    locationAdvantage: parseJSON(item.locationAdvantage || item.locationAdvantage || "[]"),
                };
            };

            const combined = [
                ...json1.map(item => ({ ...item, type: "resident", ...parseProps(item) })),
                ...json2.map(item => ({ ...item, type: "commercial", ...parseProps(item) })),
                ...json3.map(item => ({ ...item, type: "rent", ...parseProps(item) }))
            ];

            const uniqueData = combined.filter(
                (value, index, self) =>
                    index === self.findIndex((t) => t.property_id === value.property_id)
            );

            const sortedData = uniqueData.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
            setData(sortedData); // ✅ This replaces all 3 separate states
        } catch (error) {
            console.log("Error loading data:", error);
        }
    };
    useEffect(() => {


        fetchAll();
    }, []);


    const handleDelete = async (id, typeofproperty) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "This action will delete the property permanently!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
        });

        if (result.isConfirmed) {
            try {
                await fetch(`${BASE_URL}/${typeofproperty === "Residential" ? "resident" : typeofproperty === "Commercial" ? "commercial" : typeofproperty === "Rent Residential" ? "rentresident" : null}/delete-store/${id}`, {
                    method: "DELETE",
                });
                fetchAll();

                Swal.fire("Deleted!", "The property has been deleted.", "success");
            } catch (error) {
                console.error("Error deleting property:", error);
                Swal.fire("Error!", "Failed to delete the property. Try again later.", "error");
            }
        }
    };

    const handleEdit = (id, propertytype) => {
        if (propertytype === "Residential") {
            navigate(`/resident-property/${id}`);
        } else if (propertytype === "Commercial") {
            navigate(`/commercial-addproperty/${id}`);
        } else if (propertytype === "Rent Residential") {
            navigate(`/rent-addproperty/${id}`);
        } else {
            console.error("Unknown property type:", propertytype);
            return;
        }
        // console.log('Edit clicked for item at index:', index);
        // Implement actual edit logic here
    };



    // const groupProperties = (properties) => {
    //     const grouped = {};

    //     properties.forEach((property) => {
    //         const flatTypes = Array.isArray(property.flatType) ? property.flatType : [];

    //         flatTypes.forEach((flat) => {
    //             const key = `${property.building_name}_${flat?.type}`;
    //             if (!grouped[key]) {
    //                 grouped[key] = {
    //                     ...property,
    //                     mergedFlatType: flat?.type,
    //                     mergedCarpetAreas: [],
    //                     mergedExpectedPrices: [],
    //                 };
    //             }

    //             const builtUpAreas = flat.builtUpAreas || [];
    //             builtUpAreas.forEach((area) => {
    //                 if (area.value) grouped[key].mergedCarpetAreas.push(area.value);
    //                 if (area.expectedPrice) grouped[key].mergedExpectedPrices.push(formatPrice(area.expectedPrice));
    //             });
    //         });
    //     });

    //     return Object.values(grouped);
    // };

    // const combinedData = [...residentData, ...commData, ...rentData];
    // const uniqueData = combinedData.filter(
    //     (value, index, self) =>
    //         index === self.findIndex((t) => t.property_id === value.property_id)
    // );

    const filteredData = data.filter((item) =>
        ['building_name', 'address', 'ownership'].some((key) =>
            String(item[key]).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );


    // const visibleData = filteredData.filter(
    //     (item) => item.mergedCarpetAreas.length > 0 && item.mergedExpectedPrices.length > 0
    // );

    const totalPages = Math.ceil(filteredData.length / itemsPerPage);
    const currentData = filteredData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
    console.log(currentData)
    return (
        <>
            <Sidebar />
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <div className="oms-header">
                    <h1 className="dashboard-title">Our Property</h1>
                    <div className="property-dropdown-wrapper">
                        <button
                            className="oms-add-btn"
                            onClick={() => setIsOpen(!isOpen)}
                        >
                            Add Property
                        </button>

                        {isOpen && (
                            <ul className="property-dropdown-menu">
                                <li onClick={() => handleNavigate('/resident-addproperty')}>
                                    Add Resident
                                </li>
                                <li onClick={() => handleNavigate('/commercial-addproperty')}>
                                    Add Commercial
                                </li>
                                <li onClick={() => handleNavigate('/rent-addproperty')}>
                                    Add Rent
                                </li>
                            </ul>
                        )}
                    </div>
                </div>

                <div className="filter-search">
                    <div className="filter-search-input">
                        <input
                            type="search"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                        <i className="fa fa-search"></i>
                    </div>
                </div>

                <div className="customer-table">
                    <table>
                        <thead>
                            <tr>
                                <th>Actions</th>
                                <th>Project Name</th>
                                <th>Address</th>
                                <th>Amenities</th>
                                <th>Total Floors</th>
                                <th>Floor Level</th>
                                <th>Availability</th>
                                <th>Age of Building (Years)</th>
                                <th>Ownership</th>
                                <th>Property Type</th>
                                <th>Facing</th>
                                <th>Parking</th>
                                <th>Security Deposit (₹)</th>
                                <th>Location Advantages</th>
                                <th>Flat Type</th>
                                <th>Carpet Area (sq ft)</th>
                                <th>Expected Price (₹)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentData?.length > 0 ? (
                                currentData?.map((property, index) => {
                                    const validFlatTypes = (property.flatType || []).filter(
                                        (flat) => Array.isArray(flat.builtUpAreas) && flat.builtUpAreas.some(area => area.value && area.value.trim() !== "")
                                    );

                                    if (validFlatTypes.length === 0) {
                                        // ✨ No valid builtUpAreas → show basic property info
                                        return (
                                            <tr key={index}>
                                                <td>
                                                    <button className="edit-button" onClick={() => handleEdit(property.property_id, property.typeofproperty)}>
                                                        <i className="fa-solid fa-pencil edit-oms"></i>
                                                    </button>
                                                    <button className="delete-button" onClick={() => handleDelete(property.id, property.typeofproperty)}>
                                                        <i className="fa-solid fa-trash delete-oms"></i>
                                                    </button>
                                                </td>
                                                <td><ExpandableCell content={property.building_name} /></td>
                                                <td><ExpandableCell content={property.address} /></td>
                                                <td>
                                                    <ExpandableCell
                                                        content={(property.amenities || []).length > 0 ? property.amenities.join(", ") : "-"}
                                                    />
                                                </td>
                                                <td>{property.totalFloors || '-'}</td>
                                                <td>{property.floorLevel || '-'}</td>
                                                <td>{property.availabilityStatus || '-'}</td>
                                                <td>{property.ageOfBuilding || '-'}</td>
                                                <td>{property.ownership || '-'}</td>
                                                <td>{property.typeofproperty || '-'}</td>
                                                <td>{property.facing || '-'}</td>
                                                <td>{property.parking || '-'}</td>
                                                <td>{property.securityDeposit ? formatPrice(property.securityDeposit) : '-'}</td>
                                                <td>
                                                    <ExpandableCell
                                                        content={(property.locationAdvantage || []).length > 0 ? property.locationAdvantage.join(", ") : "-"}
                                                    />
                                                </td>
                                                <td>-</td> {/* Flat Type */}
                                                <td>-</td> {/* Carpet Area */}
                                                <td>-</td> {/* Expected Price */}
                                            </tr>
                                        );
                                    }

                                    return (
                                        <React.Fragment key={index}>
                                            {validFlatTypes.length > 0 ? (
                                                validFlatTypes.map((flat, flatIndex) => (
                                                    <tr key={`${index}-${flatIndex}`}>
                                                        {flatIndex === 0 && (
                                                            <>
                                                                <td rowSpan={validFlatTypes.length}>
                                                                    <button className="edit-button" onClick={() => handleEdit(property.property_id, property.typeofproperty)}>
                                                                        <i className="fa-solid fa-pencil edit-oms"></i>
                                                                    </button>
                                                                    <button className="delete-button" onClick={() => handleDelete(property.id, property.typeofproperty)}>
                                                                        <i className="fa-solid fa-trash delete-oms"></i>
                                                                    </button>
                                                                </td>
                                                                <td rowSpan={validFlatTypes.length}><ExpandableCell content={property.building_name} /></td>
                                                                <td rowSpan={validFlatTypes.length}><ExpandableCell content={property.address} /></td>
                                                                <td rowSpan={validFlatTypes.length}>
                                                                    <ExpandableCell
                                                                        content={(property.amenities || []).length > 0 ? property.amenities.join(", ") : "-"}
                                                                    />
                                                                </td>
                                                                <td rowSpan={validFlatTypes.length}>{property.totalFloors || '-'}</td>
                                                                <td rowSpan={validFlatTypes.length}>{property.floorLevel || '-'}</td>
                                                                <td rowSpan={validFlatTypes.length}>{property.availabilityStatus || '-'}</td>
                                                                <td rowSpan={validFlatTypes.length}>{property.ageOfBuilding || '-'}</td>
                                                                <td rowSpan={validFlatTypes.length}>{property.ownership || '-'}</td>
                                                                <td rowSpan={validFlatTypes.length}>{property.typeofproperty || '-'}</td>
                                                                <td rowSpan={validFlatTypes.length}>{property.facing || '-'}</td>
                                                                <td rowSpan={validFlatTypes.length}>{property.parking || '-'}</td>
                                                                <td rowSpan={validFlatTypes.length}>
                                                                    {property.securityDeposit ? formatPrice(property.securityDeposit) : '-'}
                                                                </td>
                                                                <td rowSpan={validFlatTypes.length}>
                                                                    <ExpandableCell
                                                                        content={(property.locationAdvantage || []).length > 0 ? property.locationAdvantage.join(", ") : "-"}
                                                                    />
                                                                </td>
                                                            </>
                                                        )}
                                                        <td>{flat.type || '-'}</td>
                                                        <td>
                                                            <ExpandableCell
                                                                content={
                                                                    flat.builtUpAreas.filter((area) => area.value).map((area) => area.value).join(", ") || "-"
                                                                }
                                                            />
                                                        </td>
                                                        <td>
                                                            <ExpandableCell
                                                                content={
                                                                    flat.builtUpAreas.filter((area) => formatPrice(area.expectedPrice)).map((area) => formatPrice(area.expectedPrice)).join(", ") || "-"
                                                                }
                                                            />
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="16" style={{ textAlign: 'center' }}>No flat type data.</td>
                                                </tr>
                                            )}
                                        </React.Fragment>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td colSpan="16" style={{ textAlign: 'center' }}>No data found.</td>
                                </tr>
                            )}
                        </tbody>

                    </table>
                </div>

                <div className="pagination">
                    <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
                        <i class="fa-solid fa-chevron-left"></i><i class="fa-solid fa-chevron-left"></i>
                    </button>

                

                    <button className="active">
                        {currentPage}
                    </button>

                    {currentPage < totalPages && (
                        <button onClick={() => paginate(currentPage + 1)}>
                            {currentPage + 1}
                        </button>
                    )}

                    {currentPage + 1 < totalPages && (
                        <span className="dots">...</span>
                    )}

                    {currentPage !== totalPages && (
                        <button onClick={() => paginate(totalPages)}>
                            {totalPages}
                        </button>
                    )}

                    <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages}>
                        <i class="fa-solid fa-chevron-right"></i><i class="fa-solid fa-chevron-right"></i>
                    </button>
                </div>
            </div>
        </>
    );
};

export default MyProjectUpdated;
